import * as React from 'react';
import { Delete } from '../../../../icons';
import { MenuItem, SmallMenuList } from '../../../small-menu-list';
import { RoleData, UserData, UserMenuInfo } from '../../interfaces';
import { Styled } from '../../styled';
import { UserRolesMenuItem } from './user-roles-menu-item';

interface Props {
  user: UserData;
  userMenu: UserMenuInfo;
  userRoles: RoleData[];
  closeMenu: () => void;
  changeUserRole: (email: string, role: RoleData) => void;
  deleteUser: (email: string) => void;
}

export const UserMenu: React.FC<Props> = ({ userMenu, changeUserRole, deleteUser, user, closeMenu, userRoles }) => {
  const changeUserRoleHandler = React.useCallback((role: RoleData) => changeUserRole(user.email, role), [user]);
  const deleteUserHandler = React.useCallback(() => deleteUser(user.email), [user]);
  return (
    <Styled.UserMenuListContainer userMenu={userMenu}>
      <SmallMenuList onExit={closeMenu} emergencePlace={'right top'}>
        {changeUserRole &&
          <Styled.RolesMenuItems>
            {userRoles.map(role =>
              (<UserRolesMenuItem
                key={role.id}
                role={role}
                onSelectRole={changeUserRoleHandler}
                isActive={role.name === user.accountRole}
              />),
            )}
          </Styled.RolesMenuItems>}
        {deleteUser &&
          <Styled.DeleteUserMenuItem>
            <MenuItem text={'Delete'} Icon={Delete} onClick={deleteUserHandler} />
          </Styled.DeleteUserMenuItem>
        }
      </SmallMenuList>
    </Styled.UserMenuListContainer>
  );
};
